// extracted by mini-css-extract-plugin
module.exports = {"title":"product-module--title--1sVk7","p":"product-module--p--1DjZ_","button":"product-module--button--2JQ-_"};